import React, {Component} from 'react'
import Loading from '../../pages/Loading'
import { loadProperties } from '../../../helpers/properties';

class PropertiesRouteMiddleware extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      error: false
    }
  }

  componentDidMount() {
    loadProperties().then(loaded => {
      this.setState({
        loaded: loaded
      })
    }).catch(reason => {
      this.setState({
        loaded: true,
        error: true
      })
    })
  }

  render() {
    if (!this.state.loaded) {
      return <Loading/>
    }

    return this.props.children
  }
}

export default PropertiesRouteMiddleware
